module.exports = __webpack_public_path__ + "img/esmeralda.ed06d033.png";